import { Checkbox } from "@material-ui/core";
import React from "react";
import styled from "styled-components";

const Control = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    user-select: none;
    white-space: nowrap;
    color: #222;
    font-family: "Source Sans Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
`;

const ControlCheckbox = styled(Checkbox)`
    && {
        padding: 0px;
    }
`;

export function LabeledCheckbox({
    checked,
    label,
    onChange,
    hasData = true,
}: {
    checked: boolean;
    label: string;
    onChange: (checked: boolean) => void;
}) {
    return (
        <Control>
            <ControlCheckbox
                color="primary"
                size="small"
                checked={checked}
                onChange={event => onChange(event.target.checked)}
            />
            <span>{label}</span>
        </Control>
    );
}
